import Header from "./Header";
import "./Career.css"
import Footer from "./Footer";



function Career(){
 return (
   <div>
    <Header />

    <div className="container-fluid our-mission">
    
    <h2 className="heading-text">Job at LEVINA </h2>
    <div className="row">
    <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 text-justify">

    LEVINA will offer a truly global career in project management and project execution. We provide a wide range of experience across different terrains, different cultures, and different execution methods.
 
We offer unmatched leadership opportunities & growth. Our approach is built on empowering employees to take on challenging assignments and explore their potential. We strongly believe in developing multi-skilled leaders from within our in-house talent pool. If you are looking for a challenging career with diversified opportunities, then LEVINA is the right place for you. We help shape the Leaders of Tomorrow.
    

Levina is a team of  diverse professionals spread across the globe. We combine a proven track record of successfully executing projects in difficult conditions and professional expertise. We create high performing mangers through global exposure and empowerment, woven together with a culture of trust & caring, happiness and Outperformance.

 

 Levina offers a truly global career in project management and project execution. We provide a wide range of experience across different terrains, different cultures, and different execution methods.

 

We offer unmatched leadership opportunities & growth. Our approach is built on empowering employees to take on challenging assignments and explore their potential. We strongly believe in developing multi-skilled leaders from within our in-house talent pool. If you are looking for a challenging career with diversified opportunities, then KEC International is the right place for you. We help shape the Leaders of Tomorrow.
</div>
</div>
</div>


<div className="container-fluid our-mission">
    
    <h2 className="heading-text">Life at LEVINA  </h2>
    <div className="row">
    <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 text-justify">

    At LEVINA we believe in building our leadership pipeline by nurturing, empowering and enabling our internal talent. Ensures that our internal talent is given first preference to opportunities. This makes our Learning and of paramount importance. The learning strategy at LEVINA is based on the principle of providing customized learning experience to every employee by means of creating a personalized Development Action Plan, 
Creation and actioning of job rotation, potential assessment, 360-degree feedback, and assessment and development centers are additional initiatives that we undertake to prepare our internal talent for current and future roles. At LEVINA, we take keen interest in the development of our employees, for we believe that the growth of our people is imperative for the growth of the organization.
</div>
</div>
</div>




<div className="container-fluid ">
    
    <div className="row">
        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 text-justify"><p className=""> 
      Send your CV to mentioned email
</p>

<p> <b>Email :</b>info@levinaindia.com </p>
</div>
     
    </div>
</div>

<Footer />
   </div>
 );
 
}

export default Career;